import React from 'react';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'Components/Modal';
import { PrimaryButton, SecondaryButton } from 'Components/Button';

import WaitlistApi from 'Services/Api/Admin/Waitlist';

const STATUS_OPTIONS = [
    { value: 'confirmed_in_person', label: 'Confirmed In-Person' },
    { value: 'external_waitlist',   label: 'External Waitlist'   },
    { value: 'internal_waitlist',   label: 'Internal Waitlist'   },
    { value: 'virtual',             label: 'Virtual'             },
    { value: 'cancelled',           label: 'Cancelled'           },
];

export default class ChangeStatusModal extends React.Component {
    state = {
        selectedStatus: this.props.user?.attendance_status ?? 'confirmed_in_person',
        waitlistPriority: this.props.user?.waitlist_priority ?? 0,
        working: false,
    };

    handleSubmit = async () => {
        const { user, onClose } = this.props;
        const { selectedStatus, waitlistPriority } = this.state;

        this.setState({ working: true });

        await WaitlistApi.updateUserStatus(user.id, {
            attendance_status: selectedStatus,
            waitlist_priority: waitlistPriority,
        });

        this.setState({ working: false });
        onClose();
    };

    render() {
        const { user, onClose } = this.props;
        const { selectedStatus, waitlistPriority, working } = this.state;

        return (
            <Modal>
                <ModalHeader onClose={onClose}>
                    Change Attendance Status
                </ModalHeader>

                <ModalBody>
                    <p className="mb-3 text-sm text-gray-700">
                        <strong>{user?.first_name} {user?.last_name}</strong> — {user?.email}
                    </p>

                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        New Status
                    </label>
                    <select
                        className="border border-gray-300 rounded px-3 py-2 text-sm w-full mb-4"
                        value={selectedStatus}
                        onChange={(e) => this.setState({ selectedStatus: e.target.value })}
                    >
                        {STATUS_OPTIONS.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </select>

                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Waitlist Priority (0 = lowest, 9 = highest)
                    </label>
                    <input
                        type="number"
                        min="0"
                        max="9"
                        step="1"
                        className="border border-gray-300 rounded px-3 py-2 text-sm w-full"
                        value={waitlistPriority}
                        onChange={(e) => this.setState({ waitlistPriority: Math.min(9, Math.max(0, parseInt(e.target.value) || 0)) })}
                    />
                </ModalBody>

                <ModalFooter alignment="center">
                    <SecondaryButton
                        className="mr-2"
                        text="Cancel"
                        onClick={onClose}
                    />
                    <PrimaryButton
                        text={working ? 'Saving…' : 'Save'}
                        onClick={this.handleSubmit}
                        working={working}
                    />
                </ModalFooter>
            </Modal>
        );
    }
}



